import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
export function RequireAuth({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    isAuthenticated,
    loading
  } = useAuth();
  const location = useLocation();
  if (loading) {
    return <div className="min-h-screen bg-[#0B0B0B] flex items-center justify-center" data-id="element-59">
        <div className="w-8 h-8 border-2 border-white/10 border-t-white rounded-full animate-spin" data-id="element-60" />
      </div>;
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{
      from: location
    }} replace data-id="element-61" />;
  }
  return <>{children}</>;
}